<template>
  <div class="page-header" :class="{ transparent: mode === 'transparent' }">
    <div class="navbar">
      <div class="logo">
        <img
          style="height: 26px; cursor: pointer"
          :src="logoUrl"
          @click="toHome"
        />
      </div>
      <div
        class="flex row-right tab-switch-box"
        :class="{ 'second-tab-switch-box': !isFirstNav }"
      >
        <div
          v-if="isFirstNav"
          class="tab-item"
          :style="{ color: mode === 'transparent' ? '#fff' : '#333' }"
          @click="goSecondNavPage"
        >
          服务介绍
        </div>
        <tab-switch
          v-model="activeIndex"
          :tab-list="navbarList"
          :normal-color="mode === 'transparent' ? '#fff' : '#333'"
          :margin-right="isFirstNav ? 40 : 24"
          @changeTab="handleNavSelect"
        >
          <template #content="{ tab, tabIndex }">
            <div class="flex col-center">
              <span>{{ tab.label }}</span>
              <i
                v-if="tab.route.meta && tab.route.meta.icon"
                class="iconfont text-danger m-l-2"
                style="font-weight: normal"
                :class="tab.route.meta.icon"
                :style="tab.route.meta.iconStyle || ''"
              ></i>
              <template v-if="tab.children && tab.children.length">
                <i class="el-icon-arrow-down el-icon--right"></i>
                <div class="sub-tab">
                  <div class="sub-tab-content">
                    <div
                      v-for="(child, index) in tab.children"
                      :key="index"
                      class="sub-tab-item"
                      :class="{
                        active:
                          activeIndex === tabIndex && activeSubIndex === index
                      }"
                      @click="handleNavSelect(tabIndex, index)"
                    >
                      {{ child.label }}
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </template>
        </tab-switch>

        <div v-if="isLogin" class="user-info-wrapper m-l-38">
          <el-avatar style="cursor: pointer" :size="32" :src="avatarUrl" />
          <div class="user-info-popover">
            <div class="user-info-base flex flex-align__between">
              <div class="flex">
                <el-avatar :size="48" :src="avatarUrl" />
                <div class="m-l-12">
                  <div class="font-18 text-bold text-color">
                    {{ userData.nickname }}
                  </div>
                  <div class="m-t-4 font-12">{{ userData.mobile }}</div>
                </div>
              </div>
            </div>
            <div class="user-info-vip m-t-20" :class="`${vipData.vipLevel}`">
              <div class="flex flex-align__between">
                <div class="flex">
                  <img :src="vipData.img" width="44px" />
                  <div class="m-l-12">
                    <div
                      class="font-18 text-bold text-color"
                      :class="
                        vipData.vipLevel ? `text-${vipData.vipLevel}` : ''
                      "
                    >
                      {{ vipData.vipLabel }}
                    </div>
                    <div
                      v-if="vipData.vipLevel && vipData.endTime"
                      class="m-t-4 font-12"
                    >
                      {{ vipData.endTime }}到期
                    </div>
                  </div>
                </div>
                <div
                  class="user-info-base__icon"
                  @click.prevent="
                    toPersonalCenter(vipData.vipLevel ? 'vip-home' : '')
                  "
                >
                  <span class="font-14">{{
                    vipData.vipLevel ? '会员中心' : '个人中心'
                  }}</span>
                  <i class="el-icon-arrow-right"></i>
                </div>
              </div>
              <div
                v-if="!vipData.vipLevel"
                class="user-info-vip__no flex flex-align__between m-t-15"
              >
                <div>
                  <div class="font-14 text-bold text-color">购买会员</div>
                  <div class="font-12 m-t-8">
                    CA全年不限次数，专人指导快人一步
                  </div>
                </div>

                <div class="open-btn" @click="handleVipBuy">立即开通</div>
              </div>
            </div>

            <div class="user-info-navigation m-t-16 flex flex-align__between">
              <div
                v-for="(item, index) in userNavigationList"
                :key="index"
                class="user-info-navigation__item"
                @click="item.event"
              >
                <i :class="`font-24 iconfont icon-${item.icon}`"></i>
                <div class="m-t-8">{{ item.title }}</div>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="login-button" @click="toLogin">
          <a-icon class="m-r-6" type="user" />
          <span>登录</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 组件
import TabSwitch from '@/components/common/TabSwitch'
// 路由
import { routes, useRoute } from '@/router'
// 状态
import { mapState } from 'vuex'
// 工具
import { addQueryToUrl, toLogin, toVipBuy } from '@/utils/common'
// 接口
import { getFileUrlByFileIdApi } from '@/api/file'
import alifeLogger from '@/plugins/alife-logger'
// 字典
import { valueAddedProductCodeDict } from '@/dictionary/value-added'

export default {
  name: 'PageHeader',

  components: { TabSwitch },

  props: {
    // 模式，可选值：default, transparent
    mode: {
      type: String,
      default: 'default',
      validator: (value) => ['default', 'transparent'].indexOf(value) !== -1
    }
  },

  data() {
    return {
      timer: null,
      activeIndex: '',
      activeSubIndex: '',
      barOffset: 0,
      navbarList: [],
      avatarUrl:
        'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png',
      isFirstNav: true
    }
  },

  computed: {
    ...mapState('user', [
      'isLogin',
      'userInfo',
      'isPortraitBtnShow',
      'vipInfo',
      'userInfo'
    ]),
    ...mapState('system', ['platformConfig']),

    logoUrl() {
      // return this.mode === 'transparent'
      //   ? require('@/assets/images/logo-white.png')
      //   : require('@/assets/images/logo.png')
      return this.mode === 'transparent'
        ? this.platformConfig.whiteLogo
        : this.platformConfig.logo
    },

    userData() {
      return {
        mobile: this.userInfo?.credentials?.mobile || '',
        nickname: this.userInfo?.userInfo?.nickname || ''
      }
    },

    vipData() {
      const obj = {
        [valueAddedProductCodeDict.REGULAR_VIP.alias]: {
          label: '基础版',
          img: require('@/assets/images/user/vip3.png')
        },
        [valueAddedProductCodeDict.ADVANCED_VIP.alias]: {
          label: '高级版',
          img: require('@/assets/images/user/vip1.png')
        },
        [valueAddedProductCodeDict.DIAMOND_VIP.alias]: {
          label: '钻石版',
          img: require('@/assets/images/user/vip2.png')
        }
      }

      const endTimeArr = (this.vipInfo?.timeInfo?.endTime || '').split(' ')
      return {
        vipLevel: this.vipInfo?.vipLevel || '',
        vipLabel: this.vipInfo?.vipLevel
          ? obj[this.vipInfo?.vipLevel]?.label
          : '普通用户',
        img: this.vipInfo?.vipLevel
          ? obj[this.vipInfo?.vipLevel]?.img
          : require('@/assets/images/user/no-vip.png'),
        endTime: endTimeArr && endTimeArr.length ? endTimeArr[0] : ''
      }
    },

    userNavigationList() {
      return [
        {
          title: '分析记录',
          icon: '-_fenxi',
          event: () => {
            this.toPersonalCenter('portrait-record')
          }
        },
        {
          title: '数据导出记录',
          icon: 'shujudaochujilu',
          event: () => {
            this.toPersonalCenter('custom-data')
          }
        },
        { title: '退出登录', icon: 'tuichudenglu', event: () => this.logout() }
      ]
    }
  },

  watch: {
    $route: {
      handler() {
        this.updateActiveIndex()
      },
      immediate: true,
      deep: true
    },
    navbarList() {
      this.updateActiveIndex()
    },
    isPortraitBtnShow: {
      handler(val) {
        if (this.isLogin) {
          this.filterNavBar()
        }
      },
      immediate: true
    }
  },

  async created() {
    await this.$store
      .dispatch('user/checkLogin')
      .then(async () => {
        await this.$store.dispatch('user/getUserBasicInfo').then((res) => {
          this.getAvatarUrl(res.data.userInfo.face)
        })
        await this.$store.dispatch('user/getUserVipInfo')
        await this.$store.dispatch('user/getBiddogGray')
      })
      .catch((err) => {})
    alifeLogger()
    this.filterNavBar()
    this.setIndexByRoute()
  },

  beforeDestroy() {
    clearTimeout(this.timer)
  },

  methods: {
    updateActiveIndex() {
      this.activeIndex = this.navbarList.findIndex((item) => {
        console.log(item)
        if (item.children?.length) {
          const subIndex = item.children.findIndex((subItem) => {
            const firstPath = subItem.route?.path?.split('/')[1]
            return this.$route.path.startsWith(`/${firstPath}`)
          })
          if (subIndex !== -1) {
            this.activeSubIndex = subIndex
            return true
          }
        }
        return this.$route.path.includes(item.route?.path)
      })
    },

    setIndexByRoute() {
      const currentRoute = useRoute()
      const index = this.navbarList.findIndex((item) =>
        currentRoute.path.includes(item.route.path)
      )
      this.activeIndex = index
    },

    handleNavSelect(index, childIndex = -1) {
      if (index < 0 || index === '') return
      const nav =
        childIndex === -1
          ? this.navbarList[index].route
          : this.navbarList[index].children[childIndex].route
      if (!nav.path) {
        this.updateActiveIndex()
        return
      }
      const currentPath = useRoute()
      if (currentPath.path === nav.path) return
      this.$router.push({
        path: nav.path
      })
    },

    toLogin,

    logout() {
      this.timer = setTimeout((_) => {
        sessionStorage.setItem('popupShow', 'close')
      }, 500)
      this.$store.dispatch('user/logout')
    },

    /**
     * 获取头像链接
     */
    getAvatarUrl(fileId) {
      if (!fileId) {
        this.avatarUrl =
          'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png'
        return
      }

      getFileUrlByFileIdApi({ attachmentId: fileId })
        .then((res) => {
          this.avatarUrl =
            res.data?.external ||
            'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png'
        })
        .catch((err) => {
          console.error('获取头像链接失败', err)
          if (err?.message) this.$message.error(err?.message)
        })
    },

    /**
     * 前往首页
     */
    toHome() {
      const currentRoute = useRoute()
      if (currentRoute.name === 'Home') return

      this.$router.push({
        name: 'Home'
      })
    },

    /**
     * 会员购买
     */
    handleVipBuy() {
      toVipBuy(this.$router)
    },

    /**
     * 前往个人中心的相应模块
     */
    toPersonalCenter(moduleName = '') {
      this.$store.dispatch('system/toPlatform', {
        platform: 'login',
        path: moduleName
          ? `/personal-center/value-added-services/${moduleName}`
          : '/personal-center',
        query: {
          returnUrl: encodeURIComponent(window.location.href)
        }
      })
    },
    // 过滤header菜单
    filterNavBar() {
      const currentPath = useRoute()
      const firstRouteName = currentPath.meta?.firstRouteName || ''
      if (firstRouteName) {
        this.isFirstNav = false
        this.navbarList = (routes || [])
          .filter((item) => {
            return (
              item.meta?.firstRouteName &&
              item.meta.firstRouteName === firstRouteName
            )
          })
          .map((item) => {
            return {
              label: item.meta.title,
              route: item
            }
          })
        return
      }
      this.isFirstNav = true
      const navbarListTemp = []
      ;(routes || [])
        .filter((item) => {
          // 未登录及灰度未包含该用户的情况下不展示画像菜单
          if (!this.isPortraitBtnShow) {
            return (
              item.meta?.inNavbar &&
              item.name != 'CompetitorAnalysisList' &&
              item.name != 'PurchaserAnalysisList'
            )
          } else {
            return item.meta?.inNavbar
          }
        })
        .forEach((item) => {
          if (item.meta?.routeGroup) {
            const group = navbarListTemp.find(
              (i) => i.label === item.meta.routeGroup
            )
            const child = {
              label: item.meta?.title,
              route: item
            }
            if (group) {
              group.children.push(child)
            } else {
              navbarListTemp.push({
                label: item.meta.routeGroup,
                children: [child]
              })
            }
          } else {
            navbarListTemp.push(item)
          }
        })
      this.navbarList = navbarListTemp.map((item) => {
        return {
          label: item.meta?.title || item.label,
          route: item,
          children: item.children || []
        }
      })
    },

    /**
     * 前往服务介绍
     */
    goSecondNavPage() {
      window.onbeforeunload = null
      window.open(
        addQueryToUrl(window.location.origin + '/service-introduction/home'),
        '_blank'
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.page-header {
  position: fixed;
  width: 100%;
  min-width: $body-width;
  top: 0;
  left: 0;
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid $border-color;
  background-color: $white-color;

  .navbar {
    width: $body-width;
    height: $header-height;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .login-button {
      color: $text-color;
      margin-left: 40px;
      cursor: pointer;
    }
  }

  &.transparent {
    border-bottom: 1px solid rgba(234, 234, 234, 0.25);
    background-color: rgba(255, 255, 255, 0.001);

    .login-button {
      color: $white-color;
    }
  }
}

.logo {
  display: flex;
  align-items: center;
}

.tab-switch-box {
  .tab-item {
    margin-right: 40px;
    cursor: pointer;
    position: relative;

    .label {
      position: absolute;
      display: flex;
      align-items: center;
      justify-content: center;
      top: -15px;
      right: -32px;
      padding: 2px 3px;
      color: $white-color;
      font-size: 11px;
      background: $danger-color;
      border-radius: 10px 10px 10px 0px;
    }

    &:hover {
      .sub-tab {
        display: block;
      }
    }
  }

  &.second-tab-switch-box {
    ::v-deep .tabs {
      .tab-item:not(:last-child) {
        margin-right: 24px;
      }
    }
  }

  .sub-tab {
    position: absolute;
    top: 24px;
    left: -5px;
    z-index: 999;
    text-align: left;
    display: none;

    .sub-tab-content {
      background: $white-color;
      color: #000;
      border-radius: 6px;
      box-shadow: 0 0 5px $info-third-color;
      font-size: 14px;
      font-weight: 400;
      margin: 15px 5px 5px;
      min-width: 200px;
      padding: 10px 0;
    }

    .sub-tab-item {
      padding: 6px 10px;

      &:hover {
        background: $primary-fourth-color;
        color: $primary-color;
      }

      &.active {
        color: $primary-color;
      }
    }
  }
}

.user-info-wrapper {
  position: relative;
  background: transparent;

  .user-info-popover {
    position: absolute;
    z-index: 100;
    width: 416px;
    padding: 24px;
    top: 40px;
    right: 0;
    background: $white-color;
    opacity: 0;
    visibility: hidden;
    max-height: 0px;
    transition: all 0.3s ease-out;
    transition-delay: 0.1s;
    box-shadow: 0px 2px 12px 1px rgba(0, 0, 0, 0.14);
    border-radius: 8px;

    .user-info {
      &-base {
        padding-right: 16px;
        cursor: pointer;
        color: $text-second-color;

        &__icon:hover {
          color: $text-color;
          @include text-bold;

          i {
            color: $text-color !important;
          }
        }
      }

      &-vip {
        cursor: pointer;
        border-radius: 8px;
        padding: 16px;
        color: $text-second-color;
        background: linear-gradient(180deg, #dae4f7 0%, #edf2ff 100%);

        &.diamond {
          background: linear-gradient(180deg, #e2d9ff 0%, #eeecff 100%);
        }

        &.premium {
          background: linear-gradient(180deg, #c7e4ff 0%, #e2f0ff 100%);
        }
        &.basic {
          background: linear-gradient(180deg, #fad5b2 0%, #ffecd8 100%);
        }

        &__no {
          background: rgba(255, 255, 255, 0.8);
          border-radius: 8px;
          padding: 16px;
        }

        .text-diamond {
          color: #866ce0 !important;
        }

        .text-premium {
          color: #1890ff !important;
        }

        .text-basic {
          color: #c76937 !important;
        }
      }
    }

    .user-info-navigation {
      cursor: pointer;

      &__item {
        color: $text-second-color;
        font-size: 14px;
        text-align: center;
        padding: 8px 20px;
        border-radius: 8px;

        i {
          font-size: 22px !important;
          color: $text-second-color !important;
        }

        &:hover {
          background-color: $info-fifth-color;
          color: $text-color !important;

          i {
            color: $text-color !important;
          }
        }
      }
    }
  }

  &:hover {
    .user-info-popover {
      visibility: inherit;
      opacity: 1;
      max-height: 400px;
    }
  }
}

.open-btn {
  width: 80px;
  height: 32px;
  line-height: 34px;
  text-align: center;
  background: $member-sixth-color;
  color: $member-second-color;
  font-size: 14px;
  border-radius: 4px;
  cursor: pointer;

  &:hover {
    background: $member-fifth-color;
  }
}
</style>
